/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class orderentryindex extends IceEntity {
	order_entry_index_key: string = "";
  order_entry_key: string = "";
  order_entry_group_key: string = "";
  patient_trans_account: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  src_key: string = "";
  src_type: number = 0;
  referral_key: string = "";
  order_entry_date: any = NaN;
  order_status_type: IceTypes.orderentrystatus = IceTypes.orderentrystatus.oestatusWaiting;
  order_status_note: string = "";
  last_name: string = "";
  phone: string = "";
  provider_keywords: string = "";
  merged_trans_account: string = "";
  message_key: string = "";

  order_information: string = "";
  provider_name: string = "";
  order_request_refill: string = "";
  patient_name: string = "";
  code: string = "";

  gettablename(): string {
    return "ORDER_ENTRY_INDEX";
  }
}
